export const _setLastName= (state, action) => {
    state.lastName = action.payload;
};

export const _setFirstName= (state, action) => {
    state.firstName = action.payload;
};

export const _setMiddleName= (state, action) => {
    state.middleName = action.payload;
};

export const _setSSN= (state, action) => {
    state.SSN = action.payload;
};

export const _setDateOfBirth= (state, action) => {
    state.dateOfBirth = action.payload;
};

export const _setSuffix= (state, action) => {
    state.suffix = action.payload;
};

export const _setGender= (state, action) => {
    state.gender = action.payload;
};

export const _setEthnicityOrRace= (state, action) => {
    state.ethnicityOrRace = action.payload;
};

export const _setVeteran= (state, action) => {
    state.veteran = action.payload;
};

export const _setDeployedCombatDuty= (state, action) => {
    state.deployedCombatDuty = action.payload;
};

export const _setDiagnosedPostTraumaticStressDisorder= (state, action) => {
    state.diagnosedPostTraumaticStressDisorder = action.payload;
};

export const _setRegistration290= (state, action) => {
    state.registration290 = action.payload;
};

export const _setArsonist= (state, action) => {
    state.arsonist = action.payload;
};
